import React from 'react';
import './section2-p3.css';
import PropertyHeader from '../components/common/PropertyHeader';
import Amenities from '../components/common/Amenities';
import PropertyDescription from '../components/common/PropertyDescription';
import AgentCard from '../components/common/AgentCard';

const SectionTwoP3 = () => {
  return (
    <section className="p3-wrapper">
      <div className="p3-container">
        <PropertyHeader 
          title="Verde Heights New Villa" 
          location="Hyde Park, Cairo, Egypt" 
          price="46,000,000" 
        />
        
        <div className="p3-layout-grid">
          <div className="p3-content-left">
            <Amenities />
            <PropertyDescription />
          </div>
          <aside className="p3-sidebar-right">
            <AgentCard />
          </aside>
        </div>
      </div>
    </section>
  );
};

export default SectionTwoP3;